import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Package, ShoppingBag, LayoutDashboard, Users, Settings } from "lucide-react";

export default function AdminLayout() {
  const { user } = useApp();
  const loc = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => { setChecked(true); }, []);

  if (checked && (!user || user.role !== "admin")) {
    return <Navigate to="/admin/login" replace/>;
  }

  const nav = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, exact: true },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
    { to: "/admin/customers", label: "Customers", icon: Users },
    { to: "/admin/settings", label: "Site settings", icon: Settings },
  ];

  return (
    <div data-testid="admin-layout" className="mx-auto max-w-7xl px-4 sm:px-6 py-10 grid gap-6 md:grid-cols-[220px,1fr]">
      <aside className="border border-white/10 bg-zinc-950 p-4 h-fit sticky top-20">
        <p className="mono-label text-blue-400 mb-3">Admin</p>
        <nav className="space-y-1">
          {nav.map((n) => {
            const active = n.exact ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                to={n.to}
                className={`flex items-center gap-2 px-3 py-2 text-sm border transition-colors ${
                  active ? "bg-blue-600/20 border-blue-500/60 text-blue-300" : "border-transparent hover:border-white/10 text-white/70 hover:text-white"
                }`}
              >
                <n.icon className="h-4 w-4"/> {n.label}
              </Link>
            );
          })}
        </nav>
      </aside>
      <div>
        <Outlet/>
      </div>
    </div>
  );
}
